module.exports = __webpack_public_path__ + "media/images/partner/dailysocial-db989a1178ac4c6c61e04ba0dd0e8ebf.png";